module.exports = __webpack_public_path__ + "static/img/14.c7b62c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/14.jpg
// module id = hFrI
// module chunks = 1